<template>
  <div class="search">
    <div class="search__inner" v-if="results">
      <div class="search__searchbox  container">
        <el-input
          :placeholder="$fn.tr('ძიება') + '...'"
          v-model="input_val"
        ></el-input>
        <transition name="fade2">
          <div class="search__x-btn" v-if="input_val" @click="clear_search()">
            <svg
              class="pointer"
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
            >
              <g
                id="Group_1649"
                data-name="Group 1649"
                transform="translate(-358 -29)"
              >
                <g
                  id="Rectangle"
                  transform="translate(358 29)"
                  fill="#e7e7e7"
                  stroke="#d9d9d9"
                  stroke-miterlimit="10"
                  stroke-width="1"
                >
                  <rect width="40" height="40" rx="20" stroke="none" />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="39"
                    height="39"
                    rx="19.5"
                    fill="none"
                  />
                </g>
                <g
                  id="Group_4238"
                  data-name="Group 4238"
                  transform="translate(372 43)"
                >
                  <rect
                    id="Rectangle_543"
                    data-name="Rectangle 543"
                    width="14.142"
                    height="2.828"
                    rx="1.414"
                    transform="translate(2 0) rotate(45)"
                  />
                  <rect
                    id="Rectangle_1219"
                    data-name="Rectangle 1219"
                    width="14.142"
                    height="2.828"
                    rx="1.414"
                    transform="translate(12 2) rotate(135)"
                  />
                </g>
              </g>
            </svg>
          </div>
        </transition>
      </div>

      <div
        class="search__tags_wrapper wc-lg"
        v-if="input_val && this.results.length >= 1"
      >
        <div class="container w-100 flex wrap">
          <div
            class="search__tag flex a_center active br-6 pointer"
            @click="filter_by_tag('all', $event)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Subtraction_120"
                data-name="Subtraction 120"
                d="M-8635-1879a7.009,7.009,0,0,1-7-7,7.008,7.008,0,0,1,7-7,7.007,7.007,0,0,1,7,7A7.008,7.008,0,0,1-8635-1879Zm0-4.327h0l2.741,1.1-.2-2.95,1.9-2.269-2.867-.72-1.57-2.5-1.572,2.5-2.867.72,1.9,2.269-.2,2.95,2.744-1.1Z"
                transform="translate(8642 1892.999)"
                fill="#7063e9"
              />
            </svg>
            <span class="medium"
              >{{ $fn.tr("ყველა") }}&nbsp;{{
                "(" +
                  (this.products_result_orig.length +
                    this.news_result_orig.length +
                    this.blog_result_orig.length +
                    this.offer_result_orig.length +
                    this.others_result_orig.length) +
                  ")"
              }}</span
            >
          </div>
          <div
            class="search__tag a_center flex br-6 pointer"
            @click="filter_by_tag('products', $event)"
            v-if="this.products_result_orig.length >= 1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Subtraction_120"
                data-name="Subtraction 120"
                d="M-8635-1879a7.009,7.009,0,0,1-7-7,7.008,7.008,0,0,1,7-7,7.007,7.007,0,0,1,7,7A7.008,7.008,0,0,1-8635-1879Zm0-4.327h0l2.741,1.1-.2-2.95,1.9-2.269-2.867-.72-1.57-2.5-1.572,2.5-2.867.72,1.9,2.269-.2,2.95,2.744-1.1Z"
                transform="translate(8642 1892.999)"
                fill="#7063e9"
              />
            </svg>
            <span class="medium"
              >{{ $fn.tr("პროდუქტები") }}&nbsp;{{
                "(" + this.products_result_orig.length + ")"
              }}</span
            >
          </div>
          <div
            class="search__tag a_center flex br-6 pointer"
            @click="filter_by_tag('offers', $event)"
            v-if="this.offer_result_orig.length >= 1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Subtraction_120"
                data-name="Subtraction 120"
                d="M-8635-1879a7.009,7.009,0,0,1-7-7,7.008,7.008,0,0,1,7-7,7.007,7.007,0,0,1,7,7A7.008,7.008,0,0,1-8635-1879Zm0-4.327h0l2.741,1.1-.2-2.95,1.9-2.269-2.867-.72-1.57-2.5-1.572,2.5-2.867.72,1.9,2.269-.2,2.95,2.744-1.1Z"
                transform="translate(8642 1892.999)"
                fill="#7063e9"
              />
            </svg>
            <span class="medium"
              >{{ $fn.tr("შეთავაზებები") }}&nbsp;{{
                "(" + this.offer_result_orig.length + ")"
              }}</span
            >
          </div>
          <div
            class="search__tag a_center flex br-6 pointer"
            @click="filter_by_tag('blogs', $event)"
            v-if="this.blog_result_orig.length >= 1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Subtraction_120"
                data-name="Subtraction 120"
                d="M-8635-1879a7.009,7.009,0,0,1-7-7,7.008,7.008,0,0,1,7-7,7.007,7.007,0,0,1,7,7A7.008,7.008,0,0,1-8635-1879Zm0-4.327h0l2.741,1.1-.2-2.95,1.9-2.269-2.867-.72-1.57-2.5-1.572,2.5-2.867.72,1.9,2.269-.2,2.95,2.744-1.1Z"
                transform="translate(8642 1892.999)"
                fill="#7063e9"
              />
            </svg>
            <span class="medium"
              >{{ $fn.tr("ბლოგი") }}&nbsp;{{
                "(" + this.blog_result_orig.length + ")"
              }}</span
            >
          </div>

          <div
            class="search__tag a_center flex br-6 pointer"
            @click="filter_by_tag('news', $event)"
            v-if="this.news_result_orig.length >= 1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Subtraction_120"
                data-name="Subtraction 120"
                d="M-8635-1879a7.009,7.009,0,0,1-7-7,7.008,7.008,0,0,1,7-7,7.007,7.007,0,0,1,7,7A7.008,7.008,0,0,1-8635-1879Zm0-4.327h0l2.741,1.1-.2-2.95,1.9-2.269-2.867-.72-1.57-2.5-1.572,2.5-2.867.72,1.9,2.269-.2,2.95,2.744-1.1Z"
                transform="translate(8642 1892.999)"
                fill="#7063e9"
              />
            </svg>
            <span class="medium"
              >{{ $fn.tr("სიახლეები") }}&nbsp;{{
                "(" + this.news_result_orig.length + ")"
              }}</span
            >
          </div>
          <div
            class="search__tag a_center flex br-6 pointer"
            @click="filter_by_tag('others', $event)"
            v-if="this.others_result_orig.length >= 1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Subtraction_120"
                data-name="Subtraction 120"
                d="M-8635-1879a7.009,7.009,0,0,1-7-7,7.008,7.008,0,0,1,7-7,7.007,7.007,0,0,1,7,7A7.008,7.008,0,0,1-8635-1879Zm0-4.327h0l2.741,1.1-.2-2.95,1.9-2.269-2.867-.72-1.57-2.5-1.572,2.5-2.867.72,1.9,2.269-.2,2.95,2.744-1.1Z"
                transform="translate(8642 1892.999)"
                fill="#7063e9"
              />
            </svg>
            <span class="medium"
              >{{ $fn.tr("სხვა") }}&nbsp;{{
                "(" + this.others_result_orig.length + ")"
              }}</span
            >
          </div>
        </div>
      </div>

      <div
        class="search__results_wrapper container flex column wc-lg"
        v-if="input_val && this.results.length >= 1"
      >
        <div
          class="search__products flex column"
          v-if="products_result.length >= 1 && show_products"
        >
          <transition name="fade2">
            <div
              class="search__products--layer"
              v-if="products_result.length < products_result_orig.length"
            ></div>
          </transition>
          <h2 class="search__results--title uppercase bold">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Subtraction_117"
                data-name="Subtraction 117"
                d="M-8635-1879a7.009,7.009,0,0,1-7-7,7.008,7.008,0,0,1,7-7,7.007,7.007,0,0,1,7,7A7.008,7.008,0,0,1-8635-1879Zm0-4.327h0l2.741,1.1-.2-2.95,1.9-2.269-2.867-.72-1.57-2.5-1.572,2.5-2.867.72,1.9,2.269-.2,2.95,2.744-1.1Z"
                transform="translate(8642 1892.999)"
                fill="#7063e9"
              />
            </svg>

            {{ $fn.tr("პროდუქტები") }}&nbsp;({{ products_result_orig.length }})
          </h2>
          <router-link
            :to="_.get(product, 'menu.full.full_url')"
            class="search__product flex column"
            v-for="(product, index) in products_result"
            :key="index"
          >
            <span class="f-24 bold">{{ _.get(product.cont, "title") }}</span>
            <div
              v-if="_.get(product.cont, 'content.tabs[0].content')"
              class="search__product--teaser"
              v-html="
                highlight_text(_.get(product.cont, 'content.tabs[0].content'))
              "
            ></div>
          </router-link>
          <transition name="fade2">
            <div
              class="search__view-more button bg-light-purple j_center a_center pointer"
              @click="
                view_more(
                  products_result,
                  products_result_orig,

                  'products'
                )
              "
              v-if="products_result.length < products_result_orig.length"
            >
              <span class="bold f-white">{{ $fn.tr("Show More") }}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12.828"
                height="7.195"
                viewBox="0 0 12.828 7.195"
              >
                <path
                  id="Path"
                  d="M0,0,5,4.781,10,0"
                  transform="translate(1.414 1.414)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-width="2"
                />
              </svg>
            </div>
          </transition>
        </div>
        <div
          class="search__news flex column"
          v-if="news_result_orig.length >= 1 && show_news"
        >
          <h2 class="search__results--title uppercase bold">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Subtraction_117"
                data-name="Subtraction 117"
                d="M-8635-1879a7.009,7.009,0,0,1-7-7,7.008,7.008,0,0,1,7-7,7.007,7.007,0,0,1,7,7A7.008,7.008,0,0,1-8635-1879Zm0-4.327h0l2.741,1.1-.2-2.95,1.9-2.269-2.867-.72-1.57-2.5-1.572,2.5-2.867.72,1.9,2.269-.2,2.95,2.744-1.1Z"
                transform="translate(8642 1892.999)"
                fill="#7063e9"
              />
            </svg>

            {{ $fn.tr("სიახლეები") }}&nbsp;({{ news_result_orig.length }})
          </h2>
          <div
            class="news_list__inner--grid grid"
            :class="{ expanded: news_result.length < news_result_orig.length }"
          >
            <router-link
              :to="$store.getters['main/getSingleUrl'](_.get(item, 'cont'))"
              class="news_list__box br-12 flex column bg-gray"
              v-for="(item, index) in news_result"
              :key="index"
            >
              <div class="news_list__img_wrapper">
                <img
                  :src="_.get(item.cont, 'slider_image[0].url')"
                  class="cover"
                  :alt="
                    $route.name == 'PageViewRouter_ge' &&
                    _.get(item.cont, 'seo_keywords_ge')
                      ? _.get(item.cont, 'seo_keywords_ge')
                      : $route.name == 'PageViewRouter_en' &&
                        _.get(item.cont, 'seo_keywords_en')
                      ? _.get(item.cont, 'seo_keywords_en')
                      : ''
                  "
                />
              </div>

              <div class="news_list__text-box flex column wc-lg">
                <h2
                  class="f-18 bold uppercase search__news--title"
                  v-html="highlight_text(_.get(item.cont, 'title'))"
                ></h2>
                <h3
                  class="f-16 medium search__news--teaser"
                  v-html="highlight_text(_.get(item.cont, 'teaser'))"
                ></h3>
              </div>
            </router-link>
          </div>
          <transition name="fade2">
            <div
              class="search__view-more button bg-light-purple j_center a_center pointer"
              @click="
                view_more(
                  news_result,
                  news_result_orig,

                  'news'
                )
              "
              v-if="news_result.length < news_result_orig.length"
            >
              <span class="bold f-white">{{ $fn.tr("Show More") }}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12.828"
                height="7.195"
                viewBox="0 0 12.828 7.195"
              >
                <path
                  id="Path"
                  d="M0,0,5,4.781,10,0"
                  transform="translate(1.414 1.414)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-width="2"
                />
              </svg>
            </div>
          </transition>
        </div>

        <div
          class="search__news flex column"
          v-if="blog_result_orig.length >= 1 && show_blogs"
        >
          <h2 class="search__results--title uppercase bold">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Subtraction_117"
                data-name="Subtraction 117"
                d="M-8635-1879a7.009,7.009,0,0,1-7-7,7.008,7.008,0,0,1,7-7,7.007,7.007,0,0,1,7,7A7.008,7.008,0,0,1-8635-1879Zm0-4.327h0l2.741,1.1-.2-2.95,1.9-2.269-2.867-.72-1.57-2.5-1.572,2.5-2.867.72,1.9,2.269-.2,2.95,2.744-1.1Z"
                transform="translate(8642 1892.999)"
                fill="#7063e9"
              />
            </svg>

            {{ $fn.tr("ბლოგი") }}&nbsp;({{ blog_result_orig.length }})
          </h2>
          <div
            class="news_list__inner--grid grid"
            :class="{ expanded: blog_result.length < blog_result_orig.length }"
          >
            <router-link
              :to="$store.getters['main/getSingleUrl'](_.get(item, 'cont'))"
              class="news_list__box br-12 flex column bg-gray"
              v-for="(item, index) in blog_result"
              :key="index"
            >
              <div class="news_list__img_wrapper">
                <img
                  :src="_.get(item.cont, 'slider_image[0].url')"
                  class="cover"
                  :alt="
                    $route.name == 'PageViewRouter_ge' &&
                    _.get(item.cont, 'seo_keywords_ge')
                      ? _.get(item.cont, 'seo_keywords_ge')
                      : $route.name == 'PageViewRouter_en' &&
                        _.get(item.cont, 'seo_keywords_en')
                      ? _.get(item.cont, 'seo_keywords_en')
                      : ''
                  "
                />
              </div>

              <div class="news_list__text-box flex column wc-lg">
                <h2
                  class="f-18 bold uppercase search__news--title"
                  v-html="highlight_text(_.get(item.cont, 'title'))"
                ></h2>
                <h3
                  class="f-16 medium search__news--teaser"
                  v-html="highlight_text(_.get(item.cont, 'teaser'))"
                ></h3>
              </div>
            </router-link>
          </div>

          <transition name="fade2">
            <div
              class="search__view-more button bg-light-purple j_center a_center pointer"
              @click="
                view_more(
                  blog_result,
                  blog_result_orig,

                  'blog'
                )
              "
              v-if="blog_result.length < blog_result_orig.length"
            >
              <span class="bold f-white">{{ $fn.tr("Show More") }}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12.828"
                height="7.195"
                viewBox="0 0 12.828 7.195"
              >
                <path
                  id="Path"
                  d="M0,0,5,4.781,10,0"
                  transform="translate(1.414 1.414)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-width="2"
                />
              </svg>
            </div>
          </transition>
        </div>

        <div
          class="search__news flex column"
          v-if="offer_result_orig.length >= 1 && show_offers"
        >
          <h2 class="search__results--title uppercase bold">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Subtraction_117"
                data-name="Subtraction 117"
                d="M-8635-1879a7.009,7.009,0,0,1-7-7,7.008,7.008,0,0,1,7-7,7.007,7.007,0,0,1,7,7A7.008,7.008,0,0,1-8635-1879Zm0-4.327h0l2.741,1.1-.2-2.95,1.9-2.269-2.867-.72-1.57-2.5-1.572,2.5-2.867.72,1.9,2.269-.2,2.95,2.744-1.1Z"
                transform="translate(8642 1892.999)"
                fill="#7063e9"
              />
            </svg>

            {{ $fn.tr("შეთავაზებები") }}&nbsp;({{ offer_result_orig.length }})
          </h2>
          <div
            class="news_list__inner--grid grid"
            :class="{
              expanded: offer_result.length < offer_result_orig.length
            }"
          >
            <router-link
              :to="$store.getters['main/getSingleUrl'](_.get(item, 'cont'))"
              class="offers_list__box news_list__box  flex column"
              v-for="(item, index) in offer_result"
              :key="index"
            >
              <div
                class="offers_list__img_wrapper news_list__img_wrapper br-12"
              >
                <div
                  class="offers_list__label flex j_center"
                  v-if="_.get(item.cont, 'company_image[0].url')"
                >
                  <img :src="_.get(item.cont, 'company_image[0].url')" />
                </div>
                <div class="offers_list__img_overlay bg-overlay"></div>
                <h4 class="f-55 bold f-white">
                  {{ _.get(item.cont, "offer") }}
                </h4>
                <img
                  :src="item.cont.cover_image[0].url"
                  class="cover"
                  :alt="
                    $route.name == 'PageViewRouter_ge' &&
                    item.cont.seo_keywords_ge
                      ? item.cont.seo_keywords_ge
                      : $route.name == 'PageViewRouter_en' &&
                        item.cont.seo_keywords_en
                      ? item.cont.seo_keywords_en
                      : ''
                  "
                />
              </div>

              <div
                class="offers_list__text-box news_list__text-box flex column"
              >
                <h2 class="f-18 bold uppercase">
                  {{ _.get(item.cont, "title") }}
                </h2>
                <h3 class="f-16 medium">{{ _.get(item.cont, "teaser") }}</h3>
                <div class="f-16 bold uppercase f-light-purple flex a_center">
                  <svg
                    id="Group_5_Copy_3"
                    data-name="Group 5 Copy 3"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                  >
                    <path
                      id="Combined_Shape_Copy_2"
                      data-name="Combined Shape Copy 2"
                      d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                      fill="#7063e9"
                    />
                  </svg>

                  {{ $fn.tr("Get Offer") }}
                </div>
              </div>
            </router-link>
          </div>
          <transition name="fade2">
            <div
              class="search__view-more button bg-light-purple j_center a_center pointer"
              @click="
                view_more(
                  offer_result,
                  offer_result_orig,

                  'offers'
                )
              "
              v-if="offer_result.length < offer_result_orig.length"
            >
              <span class="bold f-white">{{ $fn.tr("Show More") }}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12.828"
                height="7.195"
                viewBox="0 0 12.828 7.195"
              >
                <path
                  id="Path"
                  d="M0,0,5,4.781,10,0"
                  transform="translate(1.414 1.414)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-width="2"
                />
              </svg>
            </div>
          </transition>
        </div>
        <div
          class="search__products search__others flex column"
          v-if="others_result_orig.length >= 1 && show_others"
        >
          <transition name="fade2">
            <div
              class="search__products--layer"
              v-if="others_result.length < others_result_orig.length"
            ></div>
          </transition>
          <h2 class="search__results--title uppercase bold">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Subtraction_117"
                data-name="Subtraction 117"
                d="M-8635-1879a7.009,7.009,0,0,1-7-7,7.008,7.008,0,0,1,7-7,7.007,7.007,0,0,1,7,7A7.008,7.008,0,0,1-8635-1879Zm0-4.327h0l2.741,1.1-.2-2.95,1.9-2.269-2.867-.72-1.57-2.5-1.572,2.5-2.867.72,1.9,2.269-.2,2.95,2.744-1.1Z"
                transform="translate(8642 1892.999)"
                fill="#7063e9"
              />
            </svg>

            {{ $fn.tr("სხვა") }}&nbsp;({{ others_result_orig.length }})
          </h2>
          <router-link
            :to="_.get(product, 'menu.full.full_url')"
            class="search__product flex column"
            v-for="(product, index) in others_result"
            :key="index"
          >
            <h2 class="f-24 bold" v-html="_.get(product.cont, 'title')"></h2>
            <div
              class="search__product--teaser"
              v-html="highlight_text(_.get(product.cont, 'search_teaser'))"
            ></div>
          </router-link>
          <transition name="fade2">
            <div
              class="search__view-more button bg-light-purple j_center a_center pointer"
              @click="
                view_more(
                  others_result,
                  others_result_orig,

                  'others'
                )
              "
              v-if="others_result.length < others_result_orig.length"
            >
              <span class="bold f-white">{{ $fn.tr("Show More") }}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12.828"
                height="7.195"
                viewBox="0 0 12.828 7.195"
              >
                <path
                  id="Path"
                  d="M0,0,5,4.781,10,0"
                  transform="translate(1.414 1.414)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-width="2"
                />
              </svg>
            </div>
          </transition>
        </div>
      </div>
      <div
        class="search__results_wrapper container flex j_center wc-lg"
        v-if="input_val && this.results.length == 0 && not_found"
      >
        <span class="f-55 bold">{{ $fn.tr("შედეგი არ მოიძებნა") }}</span>
      </div>
      <Interests :expanded="input_val" />
    </div>
  </div>
</template>

<script>
import fn from "@/helpers/func";
import Interests from "@/components/modules/Interests";
export default {
  components: { Interests },
  data() {
    return {
      input_val: "",
      //
      search_results: "",
      results: "",
      //
      products_result: "",
      products_result_orig: "",
      news_result: "",
      blog_result: "",
      news_result_orig: "",
      blog_result_orig: "",
      offer_result: "",
      others_result: "",
      offer_result_orig: "",
      others_result_orig: "",
      //
      not_found: false,
      // filters
      show_products: true,
      show_news: true,
      show_offers: true,
      show_blogs: true,
      show_others: true
    };
  },
  mounted() {
    this.get_results();
  },
  methods: {
    async get_results() {
      let tmp = await fn.postData("main/search", {
        searchWord: this.input_val
      });
      this.search_results = tmp.data;
      this.filter_results(this.search_results);
      this.results.length == 0 && this.input_val
        ? (this.not_found = true)
        : (this.not_found = false);
    },
    clear_search() {
      this.input_val = "";
    },
    filter_by_tag(cat_name, event) {
      this.$store.state.main.trigger_update = !this.$store.state.main
        .trigger_update;

      let slctd = document.querySelector(".search__tag.active");
      if (event.currentTarget !== slctd) {
        if (slctd) {
          slctd.classList.remove("active");
        }
        event.currentTarget.classList.add("active");
      } else {
        event.currentTarget.classList.remove("active");
      }

      switch (cat_name) {
        case "all":
          this.show_products = true;
          this.show_news = true;
          this.show_offers = true;
          this.show_blogs = true;
          this.show_others = true;
          break;
        case "products":
          this.show_products = true;
          this.show_news = false;
          this.show_offers = false;
          this.show_blogs = false;
          this.show_others = false;
          break;
        case "news":
          this.show_products = false;
          this.show_news = true;
          this.show_offers = false;
          this.show_blogs = false;
          this.show_others = false;
          break;
        case "blogs":
          this.show_products = false;
          this.show_news = false;
          this.show_offers = false;
          this.show_blogs = true;
          this.show_others = false;
          break;
        case "offers":
          this.show_products = false;
          this.show_news = false;
          this.show_offers = true;
          this.show_blogs = false;
          this.show_others = false;
          break;
        case "others":
          this.show_products = false;
          this.show_news = false;
          this.show_offers = false;
          this.show_blogs = false;
          this.show_others = true;
          break;
      }
    },
    search_in_menus(id, content_type) {
      let menus = this.$store.state.main.indx.menus;
      let _menu = {};
      if (content_type == "news") {
        menus = menus.filter(menu => menu.configs.includes("news"));
        for (let j = 0; j < menus.length; j++) {
          _menu.link = menus[j].full_url;
          _menu.titles = menus[j].titles;
          _menu.full = menus[j];
        }
      } else if (content_type == "offers") {
        menus = menus.filter(menu => menu.configs.includes("offers"));
        for (let j = 0; j < menus.length; j++) {
          _menu.link = menus[j].full_url;
          _menu.titles = menus[j].titles;
          _menu.full = menus[j];
        }
      } else {
        menus = menus.filter(menu => menu.secondary_data);
        for (let j = 0; j < menus.length; j++) {
          let secondary_data = menus[j].secondary_data.filter(
            sec => sec.page && sec.page.length !== 0
          );
          for (let k = 0; k < secondary_data.length; k++) {
            if (
              secondary_data[k].page.includes(id) &&
              secondary_data[k].page.length == 1
            ) {
              _menu.link = menus[j].full_url;
              _menu.titles = menus[j].titles;
              _menu.full = menus[j];
            }
          }
        }
      }

      return _menu;
    },

    filter_results(results) {
      let __results = [];
      let _results = _.get(results, "content");
      for (let j = 0; j < _results.length; j++) {
        let obj = {
          cont: _results[j],
          menu: this.search_in_menus(_results[j].id, _results[j].content_type)
        };
        __results.push(obj);
      }
      return (this.results = __results.filter(
        res => res.menu !== undefined && Object.entries(res.menu).length >= 1
      ));
    },
    get_products_list(products) {
      let list = products.filter(product =>
        product.menu.full.configs.includes("search_tag_product")
      );
      this.products_result_orig = list.filter(
        L => L.cont.content_type == "insurance_description"
      );
      this.products_result = this.products_result_orig.slice(0, 5);
    },
    get_news_list(news) {
      let list = news.filter(n => n.menu.full.configs.includes("news"));
      for (let j = 0; j < list.length; j++) {
        list[
          j
        ].cat = this.$store.state.main.indx.terms.news_category.filter(cat =>
          list[j].cont.news_category.includes(cat.id)
        )[0];
      }

      this.news_result_orig = list.filter(L => L.cat.slug === "news");
      this.blog_result_orig = list.filter(L => L.cat.slug === "blog");

      this.news_result = this.news_result_orig.slice(0, 2);
      this.blog_result = this.blog_result_orig.slice(0, 2);
    },
    get_offers_list(offers) {
      let list = offers.filter(n => n.cont.content_type === "offers");
      this.offer_result_orig = list;
      this.offer_result = this.offer_result_orig.slice(0, 2);
    },

    get_others_list(others) {
      this.others_result_orig = others.filter(
        L =>
          L.cont.content_type == "page" &&
          L.cont.hide_from_search == "no" &&
          L.cont.search_teaser &&
          L.cont.search_teaser.length > 1
      );
      this.others_result = this.others_result_orig.slice(0, 5);
    },

    view_more(curr_list, list, type) {
      type === "products"
        ? (this.products_result = list.slice(
            0,
            curr_list.length + curr_list.length
          ))
        : type === "news"
        ? (this.news_result = list.slice(
            0,
            curr_list.length + curr_list.length
          ))
        : type === "blog"
        ? (this.blog_result = list.slice(
            0,
            curr_list.length + curr_list.length
          ))
        : type === "offers"
        ? (this.offer_result = list.slice(
            0,
            curr_list.length + curr_list.length
          ))
        : (this.others_result = list.slice(
            0,
            curr_list.length + curr_list.length
          ));

      this.$store.state.main.trigger_update = !this.$store.state.main
        .trigger_update;
    },

    highlight_text(text) {
      let idx = text.indexOf(this.input_val);
      return idx == -1
        ? text
        : text.substring(0, idx) +
            `<span class="f-light-purple">${this.input_val}</span>` +
            text.substring(idx + this.input_val.length, text.length);
    }
  },

  computed: {},

  watch: {
    results(ns, os) {
      this.get_products_list(ns);
      this.get_news_list(ns);
      this.get_offers_list(ns);
      this.get_others_list(ns);
    },
    input_val(ns, os) {
      this.show_products = true;
      this.show_news = true;
      this.show_offers = true;
      this.show_blogs = true;
      this.show_others = true;
      this.get_results();
      this.$store.state.main.trigger_update = !this.$store.state.main
        .trigger_update;
      ns.length >= 1
        ? (this.$store.state.main.show_suggestion_banner_search = false)
        : (this.$store.state.main.show_suggestion_banner_search = true);
      this.$store.state.main.trigger_update = !this.$store.state.main
        .trigger_update;
      setTimeout(() => {
        this.$store.state.main.trigger_update = !this.$store.state.main
          .trigger_update;
      }, 200);
    }
  }
};
</script>

<style lang="sass">
.search
    position: relative
    padding-top: 147px
    &:before
        content: '';
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 39px
        opacity: 0.05
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))
    .offers_list__img_wrapper
      h4
        position: absolute
        bottom: 17px
        left: 0
        text-align: center
        z-index: 3
        width: 100%
    .news_list
      &__box
        height: auto
      &__text-box
        height: 191px
        position: relative
      &__inner--grid
        grid-template-columns: 1fr 1fr;
        &.expanded
          margin-bottom: 89px
        margin-bottom: 0
      &__img_wrapper
        height: 350px
    &__results
      &_wrapper
        padding-top: 57px
        padding-bottom: 89px
      &--title
        margin-bottom: 55px
    &__product
      margin-bottom: 56px
      .f-24
        margin-bottom: 20px
        transition: .4s
      @media (min-width: 1024px)
        &:hover
          .f-24
            color: #7063E9
      &--teaser
        -webkit-line-clamp: 3
        display: -webkit-box
        -webkit-box-orient: vertical
        text-overflow: ellipsis
        overflow: hidden
        p, span, h1, h2, h3, h4, h5, h6 
          margin: 0
          -webkit-line-clamp: 3
          display: -webkit-box
          -webkit-box-orient: vertical
          overflow: hidden
    &__products
      position: relative
      border-bottom: 1px solid  #E7E7E7
      padding-bottom: 89px
      &--layer
          position: absolute
          content: ''
          bottom: 135px
          width: 100%
          height: 221px
          background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0),  rgba(255, 255, 255, 1))
    &__others
      padding-top: 55px
    &__view-more
        position: relative
        z-index: 10
        margin: 0 auto
        width: fit-content
        padding-left: 33px
        padding-right: 33px
        padding-bottom: 15px
        padding-top: 16px
        transition: .4s
        @media (min-width: 1024px)
          &:hover
            background-color: #613DD1
        svg
          margin-right: 0
          margin-left: 16px
    &__news
      padding-top: 55px
      padding-bottom: 89px
      border-bottom: 1px solid  #E7E7E7
      &--teaser
        position: absolute
        bottom: 34px
        padding-right: 25px
        display: -webkit-box
        -webkit-line-clamp: 3
        -webkit-box-orient: vertical
        overflow: hidden
      &--title
        span
          font-size: 18px;
          line-height: 27px;
          font-family: "TBCSailec-Bold"
    &__searchbox
        position: relative
        svg
            position: absolute
            top: 0
            right: 0
            rect
                transition: .4s
            @media (min-width: 1024px)
                &:hover
                    #Rectangle_1219, #Rectangle_543
                        fill: #7063E9
    &__tags_wrapper
      background-color: #F7F7F7
      padding-bottom: 45px
      padding-top: 55px
      margin-top: 34px
    &__tag
      border: 1px solid #D9D9D9
      background-color: #F7F7F7
      width: fit-content
      margin-bottom: 10px
      padding-left: 10px
      padding-right: 10px
      padding-bottom: 8px
      padding-top: 8px
      transition: .4s
      svg
        margin-right: 7px
        path
          transition: .4s
      &:not(:last-child)
        margin-right: 10px
      &.active
        background-color: #7063E9
        span
          color: white
        svg path
          fill: white
      @media (min-width: 1024px)
        &:hover
          background-color: #7063E9
          span
            color: white
          svg path
            fill: white
    .el-input__inner
        height: 73px
        padding-bottom: 30px
        border-top: none
        border-left: none
        border-right: none
        border-bottom: 2px solid rgba(1, 4, 7, 0.05)
        font-size: 38px
        line-height: 57px
        color: #333333
        @media (min-width: 1024px)
          will-change: transform
        &::placeholder
            color: #333333
    &__x-btn
      position: absolute
      top: 0
      left: 50%
      transform: translateX(-50%)
      pointer-events: none
      width: 1110px
      svg
       pointer-events: all
    @media (max-width: 1206px)
      padding-top: 89px
      &__results_wrapper
        padding-bottom: 55px
      &__x-btn
        width: calc(100% - 94px)
      &__news, &__products
        padding-bottom: 55px
      .news_list
        &__inner--grid.expanded
          margin-bottom: 55px
        &__img_wrapper
          height: initial
          padding-bottom: calc(100% / 1.54285714286)
        &__box
          height: auto
    @media (max-width: 1023px)
      &__results--title
        margin-bottom: 34px
      &__product
        margin-bottom: 34px
      &__products
        padding-bottom: 34px
        &--layer
          bottom: 113px
      &__x-btn
        width: calc(100% - 90px)
      &__news
        &--teaser
          padding-right: 21px
    @media (max-width: 767px)
      .el-input__inner
        font-size: 21px
        line-height: 32px
        padding-bottom: 21px
      &__news
        padding-bottom: 34px
        padding-top: 34px
      &__results
        &--title
          margin-bottom: 34px
        &_wrapper
          padding-top: 34px
      .news_list
        &__inner--grid
          grid-template-columns: 1fr
          &.expanded
            margin-bottom: 34px
      &__x-btn
        width: calc(100% - 40px)
</style>
